import { useEffect, useRef } from "react";
import { useRouter } from "next/router";

export default function OrgHome() {
  const router = useRouter();
  const hasNavigated = useRef(false);

  useEffect(() => {
    // Redirect to job runs by default
    if (router.isReady && !hasNavigated.current) {
      const { org, ...queryParams } = router.query;
      if (org) {
        hasNavigated.current = true;
        // Preserve query parameters (like ?support=open) when redirecting
        const queryString = new URLSearchParams(
          Object.entries(queryParams).map(([key, value]) => [
            key,
            Array.isArray(value) ? value[0] ?? "" : value || "",
          ]),
        ).toString();
        const newPath = `/${org}/runs/jobs${
          queryString ? `?${queryString}` : ""
        }`;
        router.replace(newPath);
      }
    }
  }, [router, router.isReady, router.query]);

  return null;
}
